export default function BusinessIcon(
  props: Pick<React.SVGProps<SVGSVGElement>, "fill" | "fillOpacity">,
) {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.33464 4.16683V1.66683C6.33464 1.44582 6.42243 1.23385 6.57871 1.07757C6.73499 0.921293 6.94696 0.833496 7.16797 0.833496H13.8346C14.0556 0.833496 14.2676 0.921293 14.4239 1.07757C14.5802 1.23385 14.668 1.44582 14.668 1.66683V4.16683H18.0013C18.2223 4.16683 18.4343 4.25463 18.5906 4.41091C18.7468 4.56719 18.8346 4.77915 18.8346 5.00016V16.6668C18.8346 16.8878 18.7468 17.0998 18.5906 17.2561C18.4343 17.4124 18.2223 17.5002 18.0013 17.5002H3.0013C2.78029 17.5002 2.56833 17.4124 2.41205 17.2561C2.25577 17.0998 2.16797 16.8878 2.16797 16.6668V5.00016C2.16797 4.77915 2.25577 4.56719 2.41205 4.41091C2.56833 4.25463 2.78029 4.16683 3.0013 4.16683H6.33464ZM3.83464 13.3335V15.8335H17.168V13.3335H3.83464ZM3.83464 11.6668H17.168V5.8335H3.83464V11.6668ZM8.0013 2.50016V4.16683H13.0013V2.50016H8.0013ZM9.66797 9.16683H11.3346V10.8335H9.66797V9.16683Z"
        fill={props.fill || "#0F1324"}
        fillOpacity={props.fillOpacity || "1"}
      />
    </svg>
  );
}
